import { db } from '../lib/Firebase-config';
import { doc, getDoc, setDoc, increment, updateDoc } from 'firebase/firestore';

const LEVEL_THRESHOLDS = [0, 100, 300, 600, 1000, 1500, 2100, 2800, 3600, 4500, 5500, 6600, 7800, 9100, 10500];

export const getUserGamificationProfile = async (userId) => {
    const docRef = doc(db, 'user_gamification', userId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
        return docSnap.data();
    } else {
        const initialProfile = {
            xp: 0,
            level: 1,
            totalAnswers: 0,
            correctAnswers: 0,
            streakDays: 0
        };
        await setDoc(docRef, initialProfile);
        return initialProfile;
    }
};

export const awardXP = async (userId, amount, reason) => {
    if (!userId) return;

    const docRef = doc(db, 'user_gamification', userId);

    try {
        const docSnap = await getDoc(docRef);
        let profile = docSnap.exists() ? docSnap.data() : { xp: 0, level: 1 };

        let newXP = (profile.xp || 0) + amount;
        let newLevel = profile.level;

        // Check for level up
        while (newLevel < LEVEL_THRESHOLDS.length && newXP >= LEVEL_THRESHOLDS[newLevel]) {
            newLevel++;
            // Could trigger a level up event/notification here
        }

        // Award coins - 10% of XP
        const coinsAwarded = Math.floor(amount * 0.1);
        const newCoins = (profile.coins || 0) + coinsAwarded;

        await setDoc(docRef, {
            xp: newXP,
            level: newLevel,
            coins: newCoins,
            lastXPAwarded: new Date().toISOString(),
            lastReason: reason
        }, { merge: true });

        return {
            xpGained: amount,
            coinsGained: coinsAwarded,
            newTotalXP: newXP,
            levelUp: newLevel > profile.level,
            newLevel
        };
    } catch (error) {
        console.error("Error awarding XP:", error);
    }
};

export const purchaseItem = async (userId, itemId, cost) => {
    if (!userId) return { success: false, message: 'User not found' };
    const docRef = doc(db, 'user_gamification', userId);

    try {
        const docSnap = await getDoc(docRef);
        if (!docSnap.exists()) return { success: false, message: 'Profile not found' };

        const data = docSnap.data();
        const currentCoins = data.coins || 0;

        if (currentCoins < cost) {
            return { success: false, message: 'Not enough coins' };
        }

        // Add to inventory
        const inventory = data.inventory || [];
        if (inventory.includes(itemId)) {
            return { success: false, message: 'Item already owned' };
        }

        await updateDoc(docRef, {
            coins: increment(-cost),
            inventory: [...inventory, itemId]
        });

        return { success: true, message: 'Purchase successful', newBalance: currentCoins - cost };
    } catch (error) {
        console.error("Error purchasing item:", error);
        return { success: false, message: 'Transaction failed' };
    }
};

export const getLeaderboard = async () => {
    // Note: For a real scalable leaderboard, you'd need a dedicated collection with optimized queries.
    // For now, we'll assume we can query the top users from 'user_gamification'
    // This requires a composite index in Firestore on 'xp' descending.

    // Placeholder implementation as I cannot query collectionGroup efficiently without index setup verification
    return [];
};
